import React from 'react';

import styles from './ResponseImportRecipes.css';

const ErrorSection = props => {
  const { messages } = props;

  if (Array.isArray(messages)) {
    return (
      <div className={styles['error-list-container']}>
        {messages.map((message, i) => {
          return (
            <div key={i}>
              {i % 2 === 0 ? (
                <div className={styles['error-list-text']}>
                  <div className={styles['text-error']}>
                    {' '}
                    <strong> {message} </strong>{' '}
                  </div>
                  <div> {messages[i + 1]} </div>
                </div>
              ) : null}
            </div>
          );
        })}
      </div>
    );
  }

  return (
    <div className={styles['error-list-text']}>
      <strong> {messages} </strong>
    </div>
  );
};

export default ErrorSection;
